<template>
  <div class="silver_hearts">
    <div class="section_1">
      <div class="wrap">
        <iframe class="soundcloud" width="100%" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/508744029&amp;color=%23111111&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true"></iframe>
        <div class="tracklist">
          <div class="tracklist-section">
            <div class="track"><div class="track-label">01 - starshine</div></div>
            <div class="track"><div class="track-label">02 - volta</div></div>
            <div class="track"><div class="track-label">03 - silver hearts</div></div>
            <div class="track"><div class="track-label stub">04 - step two</div></div>
          </div>
          <div class="tracklist-section">
            <div class="track"><div class="track-label">05 - yoru</div></div>
            <div class="track"><div class="track-label">06 - magical girl</div></div>
            <div class="track"><div class="track-label stub">07 - wait for me</div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_2">
      <div class="wrap">
        <h1 class="title_2">NOW AVAILABLE</h1>
        <div class="description">Streaming on <a href="https://open.spotify.com/album/0sa4RmVFJz8nDk9hwsDF4o?si=AiH9EvDARFmoxyQTgibhzw">Spotify</a>, <a href="https://soundcloud.com/lyninx/sets/silver-hearts">Soundcloud</a>, <a href="https://itunes.apple.com/us/album/silver-hearts/1378124967">Apple Music</a>, and <a href="https://play.google.com/music/m/Bmvpuvnxrgxxd4go7ta6vrjpkfi?t=Silver_Hearts_-_lyninx">Google Play</a><!-- and <a href="#">YouTube</a> --></div>
        <div class="description">Purchase on <a href="https://lyninx.bandcamp.com/album/silver-hearts">Bandcamp</a>, <a href="https://play.google.com/store/music/album?id=Bmvpuvnxrgxxd4go7ta6vrjpkfi&tid=song-Tjmubc4ztxokmjpuyljsmqp3lva">Google Play</a>, <a href="https://www.amazon.com/Silver-Hearts-lyninx/dp/B07CR5KXZ9/ref=sr_1_1?s=dmusic&ie=UTF8&qid=1525174383&sr=1-1-mp3-albums-bar-strip-0&keywords=lyninx">Amazon</a> and <a href="https://itunes.apple.com/us/album/silver-hearts/1378124967">iTunes</a></div>
      </div>
    </div>
    <div class="section_3">
      <div class="wrap">
        <div class="credits">
          <div class="credits_title">Credits</div>
          <div class="credits_section">
            <div class="credits_row">Composition + Production by <a href="https://twitter.com/lyninxmusic">Dennis Pacewicz</a></div>
            <div class="credits_row">Illustration by <a href="https://twitter.com/Kaneblob">Kane</a></div>
            <div class="credits_row">Vocals by <a href="https://www.wakamatsuerico.com/">Erico Wakamatsu</a></div>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      message: ""
    }
  },
  created: function() {
    this.$store.dispatch('fetchRelease', 'silver-hearts').then(() => {
      console.log('fetched silver hearts')
    })
  }
}
</script>
